import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useCreateLegalMatterStatusMutation, useLegalMatterStatusAutocompleteQuery } from '../../../../../queries';
import { SearchIcon } from '../../../svgs/icons/SearchIcon';
import { TextInput } from '../../../TextInput';
import { styleSheet } from '../../SearchComponent/styles';

export const MatterStatusSearch = ({
	onSelectStatus,
	canAdd = true,
	onCreateStatus,
	initialSearchFragment,
	className,
	dropdownClassName,
	onClear,
}: {
	onSelectStatus: (status: Api.ILegalMatterStatus) => void;
	canAdd?: boolean;
	onCreateStatus?: (status: Api.ILegalMatterStatus) => void;
	initialSearchFragment?: string;
	className?: string;
	dropdownClassName?: string;
	onClear?: () => void;
}) => {
	const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
	const [searchFragment, setSearchFragment] = React.useState<string>(initialSearchFragment ?? '');
	const addStatusMutation = useCreateLegalMatterStatusMutation({
		onSuccess: (result: Api.ILegalMatterStatus) => {
			setSearchFragment(result.name);
			onCreateStatus?.(result);
			setIsDropdownOpen(false);
		},
	});

	const selectStatus = (status: Api.ILegalMatterStatus) => {
		setSearchFragment(status.name);
		setIsDropdownOpen(false);
		onSelectStatus(status);
	};

	const updateSearchFragment = (newValue: string) => {
		setSearchFragment(newValue);

		if (newValue) {
			setIsDropdownOpen(true);
		} else {
			setIsDropdownOpen(false);
			onClear?.();
		}
	};

	const createNewStatus = () => {
		const status: Api.ILegalMatterStatus = {
			name: searchFragment,
		};
		addStatusMutation.mutate({
			status,
		});
	};

	const statusAutocompleteQuery = useLegalMatterStatusAutocompleteQuery({
		enabled: !!searchFragment,
		pageSize: 25,
		fragment: searchFragment,
	});

	const statuses = statusAutocompleteQuery.data?.pages.map(page => page.values).flat() ?? [];

	return (
		<div className={`${css(styleSheet.searchInputWrap)} ${className || ''}`}>
			<TextInput
				className={css(isDropdownOpen ? styleSheet.popoverOpen : null)}
				inputId='matter-modal-edit-status'
				onChange={e => updateSearchFragment(e.target.value)}
				type='text'
				value={searchFragment}
				placeholder='Search'
				leftAccessory={<SearchIcon className={css(styleSheet.searchIcon)} />}
			/>

			{isDropdownOpen ? (
				<div className={`${css(styleSheet.dropdown)} ${dropdownClassName || ''}`}>
					{statuses.length === 0 && !statusAutocompleteQuery.isPending ? <i>No matches found</i> : null}

					{statuses.map(status => {
						return (
							<button onClick={() => selectStatus(status)} key={`status-${status.id}`}>
								{status.name}
							</button>
						);
					})}

					{canAdd && !!searchFragment ? (
						<button className={css(styleSheet.addNewButton)} onClick={createNewStatus}>
							<span>+ Add &quot;{searchFragment}&quot;</span>
						</button>
					) : null}
				</div>
			) : null}
		</div>
	);
};
